module.exports = __webpack_public_path__ + "b57314c809a677a34718891d592f2e1c.png";